import React from 'react'
import AppModal from '../common/AppModal'
import CreateOrUpdateExpenseCategoryForm from '../../forms/CreateOrUpdateExpenseCategoryForm'

interface CreateExpenseCategoryModalProps {
  open: boolean
  onClose: () => void
  loading: boolean
  error: string | null
}

const CreateExpenseCategoryModal: React.FC<CreateExpenseCategoryModalProps> = ({
  open,
  onClose,
  loading,
  error
}) => (
  <AppModal open={open} onClose={onClose} title="New Expense Category" width="md" loading={loading}>
    <CreateOrUpdateExpenseCategoryForm loading={loading} error={error} />
  </AppModal>
)

export default CreateExpenseCategoryModal
